import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieSellers($integrationId: Int, $page: Int) {
    omieSellers(integrationId: $integrationId, page: $page, limit: 30) {
      codigo
      nome
    }
  }
`

export const useSellerSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieSellers']))
      .then(data => {
        const result = data.map(item => {
          return { id: item?.codigo, name: item?.nome }
        })

        return result
      })
  }
}

const SellerSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useSellerSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default SellerSelect
